import reducer, { actions, selectors } from "./dialog";
export default reducer;
export { actions, selectors };
